export default "__VITE_ASSET__K4IS$BZP__"